import React, { PropTypes, Component } from 'react'
import moment from 'moment-timezone'
import cx from 'classnames'
import { Link } from 'react-router'

import './MultipleTimesPerWeekRecurrenceCard.scss'
import ServiceItem from './components/ServiceItem'
import TableHeader from './components/TableHeader'
import { formatDate } from 'utils/dates'
import { buildAddressString } from 'utils/addresses'
import { TIMEZONE, recurrencePeriodicity } from '@src/globals'
import * as paths from 'utils/paths'

class MultipleTimesPerWeekRecurrenceCard extends Component {
  constructor (props) {
    super(props)

    this.recurrenceMoment = moment.tz(Date.now(), TIMEZONE).day(props.recurrence.weekday).hour(props.recurrence.hour).minute(0)

    this.humanizedPeriodicity = this.humanizedPeriodicity.bind(this)
  }

  getWeekdaysNames () {
    const weekdays = {
      'monday': {
        index: 0,
        name: 'Lunes'
      },
      'tuesday': {
        index: 1,
        name: 'Martes'
      },
      'wednesday': {
        index: 2,
        name: 'Miércoles'
      },
      'thursday': {
        index: 3,
        name: 'Jueves'
      },
      'friday': {
        index: 4,
        name: 'Viernes'
      },
      'saturday': {
        index: 5,
        name: 'Sábado'
      },
      'sunday': {
        index: 6,
        name: 'Domingo'
      }
    }

    const recurrenceWeekdays = this.props.recurrence.weekdays

    return (
      recurrenceWeekdays
        .map(weekday => weekdays[weekday])
        .sort((a, b) => a.index - b.index)
        .map(weekday => weekday.name)
        .map(weekday => weekday.toLowerCase())
    )
  }

  getTime () {
    return formatDate('h:mm A', this.recurrenceMoment)
  }

  getCardTitle () {
    const weekdays = this.getWeekdaysNames()
    const time = this.getTime()
    const cardTitle = `Servicio de todos los ${weekdays.join(', ')} a las ${time}`

    return cardTitle
  }

  humanizedPeriodicity () {
    const { recurrence } = this.props
    const periodicity = recurrence ? recurrence.periodicity : 0
    return recurrencePeriodicity[periodicity].name
  }

  render () {
    const {
      recurrence,
      userId
    } = this.props

    const componentClassName = cx(
      'MultipleTimesPerWeekRecurrenceCard',
      'MultipleTimesPerWeekRecurrenceCard--recurrence'
    )

    const address = recurrence.address

    return (
      <div className={componentClassName}>
        <div className='MultipleTimesPerWeekRecurrenceCard-header'>
          <h4>
            {this.getCardTitle()}
          </h4>

          <div className='MultipleTimesPerWeekRecurrenceCard-headerInfo'>
            <div className='MultipleTimesPerWeekRecurrenceCard-periodicity'>
              {this.humanizedPeriodicity()}
            </div>

            <div className='MultipleTimesPerWeekRecurrenceCard-modifyRecurrence'>
              <Link
                className='btn btn-primary'
                to={paths.userCancelRecurrence(userId, recurrence.id)}
                >
                Cancelar todo
              </Link>
            </div>
          </div>
        </div>

        <div className='MultipleTimesPerWeekRecurrenceCard-address'>
          {buildAddressString(address)}
        </div>

        <TableHeader />

        <div className='MultipleTimesPerWeekRecurrenceCard-services'>
          {
            recurrence.services.map((service) =>
              <ServiceItem
                key={service.id}
                service={service}
                userId={userId}
              />
            )
          }
        </div>
      </div>
    )
  }
}

MultipleTimesPerWeekRecurrenceCard.displayName = 'MultipleTimesPerWeekRecurrenceCard'
MultipleTimesPerWeekRecurrenceCard.propTypes = {
  recurrence: PropTypes.shape({
    id: PropTypes.number.isRequired,
    weekday: PropTypes.string.isRequired,
    periodicity: PropTypes.number.isRequired,
    hour: PropTypes.number.isRequired
  }),
  services: PropTypes.array.isRequired,
  userId: PropTypes.string.isRequired
}
MultipleTimesPerWeekRecurrenceCard.defaultProps = {
  recurrence: null
}

export default MultipleTimesPerWeekRecurrenceCard



// WEBPACK FOOTER //
// ./src/screens/App/screens/UserProfile/screens/UserServices/screens/NextServices/components/MultipleTimesPerWeekRecurrenceCard/MultipleTimesPerWeekRecurrenceCard.js